var video_viewer_default = {
  "video_player": "Yhk-w",
  "videoOverlay": "_2V11T",
  "video_container": "fxbjr"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
